var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "drag",
        {
          staticClass: "drag",
          attrs: {
            "transfer-data": {
              visiteurID: _vm.visiteur.visiteurID,
              placePupitreActif: _vm.visiteur.placePupitre,
              menuStelected: _vm.visiteur.menuSelected,
              reponseCobrowsing: _vm.visiteur.reponseCobrowsing
            }
          },
          on: { dragstart: _vm.handleDragstart, dragend: _vm.handleDragend }
        },
        [
          _c(
            "v-toolbar",
            {
              staticClass: "grey lighten-1",
              class: { newMessage: _vm.visiteurLastMessage },
              attrs: { dark: "", dense: "" }
            },
            [
              _vm.visiteur.network
                ? _c("wz-avatar", {
                    attrs: {
                      src: _vm.visiteur.profile_pic,
                      username: _vm.visiteur.visiteurName,
                      size: "38px"
                    }
                  })
                : _vm.istypingVisiteur
                ? _c("wz-avatar", {
                    staticClass: "istypingListAttente",
                    attrs: {
                      isTyping: _vm.istypingVisiteur,
                      username: "#" + _vm.visiteur.visiteurID,
                      size: "38px",
                      chip: ""
                    }
                  })
                : !_vm.istypingVisiteur && _vm.visiteurLastMessage
                ? _c("wz-avatar", {
                    attrs: {
                      username: "#" + _vm.visiteur.visiteurID,
                      size: "38px",
                      lastMessage: ""
                    }
                  })
                : _c("wz-avatar", {
                    attrs: {
                      username: "#" + _vm.visiteur.visiteurID,
                      size: "38px"
                    }
                  }),
              _vm._v(" "),
              _c("v-flex", { attrs: { ellipsis: "", "ml-2": "" } }, [
                _c("div", { staticClass: "ellipsis" }, [
                  _vm._v(_vm._s(_vm.nameVisiteur))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "ellipsis" }, [
                  _vm._v(_vm._s(_vm.visiteur.lastMessage))
                ])
              ]),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c("wz-visiteur-timer", {
                attrs: { timeStart: _vm.visiteur.timeStampArrive },
                on: { updateSeuil: _vm.colorAttente }
              }),
              _vm._v(" "),
              _c(
                "v-menu",
                { attrs: { bottom: "", right: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { slot: "activator", icon: "", dark: "" },
                      slot: "activator"
                    },
                    [_c("v-icon", [_vm._v("more_vert")])],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list",
                    { attrs: { dense: "" } },
                    _vm._l(_vm.itemsMenu, function(item) {
                      return _c(
                        "v-list-tile",
                        {
                          key: item.title,
                          attrs: { disabled: item.disabled },
                          on: {
                            click: function($event) {
                              item.disabled
                                ? ""
                                : _vm.menuAction(item.nameAction)
                            }
                          }
                        },
                        [
                          _c(
                            "v-list-tile-action",
                            [_c("v-icon", [_vm._v(_vm._s(item.icon))])],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-list-tile-title", [_vm._v(_vm._s(item.title))])
                        ],
                        1
                      )
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          !_vm.visiteur.connexion
            ? _c("div", { staticClass: "clientAttenteOffline error" })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-dialog",
            {
              attrs: {
                fullscreen: "",
                transition: "dialog-bottom-transition",
                overlay: false
              },
              model: {
                value: _vm.dialogTransfereChat,
                callback: function($$v) {
                  _vm.dialogTransfereChat = $$v
                },
                expression: "dialogTransfereChat"
              }
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-toolbar",
                    { staticClass: "primary", attrs: { dark: "" } },
                    [
                      _c(
                        "v-menu",
                        { attrs: { bottom: "", right: "" } },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { icon: "", dark: "" },
                              nativeOn: {
                                click: function($event) {
                                  _vm.dialogTransfereChat = false
                                }
                              }
                            },
                            [_c("v-icon", [_vm._v("close")])],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list",
                            { attrs: { dense: "" } },
                            _vm._l(_vm.itemsMenu, function(item) {
                              return _c(
                                "v-list-tile",
                                {
                                  key: item.title,
                                  attrs: { disabled: item.disabled },
                                  on: {
                                    click: function($event) {
                                      item.disabled
                                        ? ""
                                        : _vm.menuAction(item.nameAction)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "v-list-tile-action",
                                    [_c("v-icon", [_vm._v(_vm._s(item.icon))])],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("v-list-tile-title", [
                                    _vm._v(_vm._s(item.title))
                                  ])
                                ],
                                1
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          !_vm.visiteur.connexion
            ? _c("div", { staticClass: "clientAttenteOffline error" })
            : _vm._e(),
          _vm._v(" "),
          _c("wz-dialog-close-chat", {
            attrs: {
              datasVisiteur: _vm.visiteur,
              dialogCloseChat: _vm.dialogCloseChat
            },
            on: { fermeDialogCloseChat: _vm.fermeDialogCloseChat }
          }),
          _vm._v(" "),
          _c("wz-dialog-transfert-chat", {
            ref: "dialogTransfert",
            attrs: { datasVisiteur: _vm.visiteur }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a3d47f44", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a3d47f44","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheebox/WzVisiteurAttente.vue
// module id = null
// module chunks = 